module.exports = __webpack_public_path__ + "static/media/glass-martini.20902087.svg";